"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowFormatter = void 0;
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const FieldFormatter_1 = require("./FieldFormatter");
const types_1 = require("../types");
class RowFormatter {
  constructor(formatterOptions) {
    this.rowCount = 0;
    this.formatterOptions = formatterOptions;
    this.fieldFormatter = new FieldFormatter_1.FieldFormatter(formatterOptions);
    this.headers = formatterOptions.headers;
    this.shouldWriteHeaders = formatterOptions.shouldWriteHeaders;
    this.hasWrittenHeaders = false;
    if (this.headers !== null) {
      this.fieldFormatter.headers = this.headers;
    }
    if (formatterOptions.transform) {
      this.rowTransform = formatterOptions.transform;
    }
  }
  static isRowHashArray(row) {
    if (Array.isArray(row)) {
      return Array.isArray(row[0]) && row[0].length === 2;
    }
    return false;
  }
  static isRowArray(row) {
    return Array.isArray(row) && !this.isRowHashArray(row);
  }
  // get headers from a row item
  static gatherHeaders(row) {
    if (RowFormatter.isRowHashArray(row)) {
      // lets assume a multi-dimesional array with item 0 being the header
      return row.map(it => it[0]);
    }
    if (Array.isArray(row)) {
      return row;
    }
    return Object.keys(row);
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  static createTransform(transformFunction) {
    if (types_1.isSyncTransform(transformFunction)) {
      return (row, cb) => {
        let transformedRow = null;
        try {
          transformedRow = transformFunction(row);
        } catch (e) {
          return cb(e);
        }
        return cb(null, transformedRow);
      };
    }
    return (row, cb) => {
      transformFunction(row, cb);
    };
  }
  set rowTransform(transformFunction) {
    if (!lodash_isfunction_1.default(transformFunction)) {
      throw new TypeError('The transform should be a function');
    }
    this._rowTransform = RowFormatter.createTransform(transformFunction);
  }
  format(row, cb) {
    this.callTransformer(row, (err, transformedRow) => {
      if (err) {
        return cb(err);
      }
      if (!row) {
        return cb(null);
      }
      const rows = [];
      if (transformedRow) {
        const {
          shouldFormatColumns,
          headers
        } = this.checkHeaders(transformedRow);
        if (this.shouldWriteHeaders && headers && !this.hasWrittenHeaders) {
          rows.push(this.formatColumns(headers, true));
          this.hasWrittenHeaders = true;
        }
        if (shouldFormatColumns) {
          const columns = this.gatherColumns(transformedRow);
          rows.push(this.formatColumns(columns, false));
        }
      }
      return cb(null, rows);
    });
  }
  finish(cb) {
    const rows = [];
    // check if we should write headers and we didnt get any rows
    if (this.formatterOptions.alwaysWriteHeaders && this.rowCount === 0) {
      if (!this.headers) {
        return cb(new Error('`alwaysWriteHeaders` option is set to true but `headers` option not provided.'));
      }
      rows.push(this.formatColumns(this.headers, true));
    }
    if (this.formatterOptions.includeEndRowDelimiter) {
      rows.push(this.formatterOptions.rowDelimiter);
    }
    return cb(null, rows);
  }
  // check if we need to write header return true if we should also write a row
  // could be false if headers is true and the header row(first item) is passed in
  checkHeaders(row) {
    if (this.headers) {
      // either the headers were provided by the user or we have already gathered them.
      return {
        shouldFormatColumns: true,
        headers: this.headers
      };
    }
    const headers = RowFormatter.gatherHeaders(row);
    this.headers = headers;
    this.fieldFormatter.headers = headers;
    if (!this.shouldWriteHeaders) {
      // if we are not supposed to write the headers then
      // always format the columns
      return {
        shouldFormatColumns: true,
        headers: null
      };
    }
    // if the row is equal to headers dont format
    return {
      shouldFormatColumns: !lodash_isequal_1.default(headers, row),
      headers
    };
  }
  // todo change this method to unknown[]
  gatherColumns(row) {
    if (this.headers === null) {
      throw new Error('Headers is currently null');
    }
    if (!Array.isArray(row)) {
      return this.headers.map(header => row[header]);
    }
    if (RowFormatter.isRowHashArray(row)) {
      return this.headers.map((header, i) => {
        const col = row[i];
        if (col) {
          return col[1];
        }
        return '';
      });
    }
    // if its a one dimensional array and headers were not provided
    // then just return the row
    if (RowFormatter.isRowArray(row) && !this.shouldWriteHeaders) {
      return row;
    }
    return this.headers.map((header, i) => row[i]);
  }
  callTransformer(row, cb) {
    if (!this._rowTransform) {
      return cb(null, row);
    }
    return this._rowTransform(row, cb);
  }
  formatColumns(columns, isHeadersRow) {
    const formattedCols = columns.map((field, i) => this.fieldFormatter.format(field, i, isHeadersRow)).join(this.formatterOptions.delimiter);
    const {
      rowCount
    } = this;
    this.rowCount += 1;
    if (rowCount) {
      return [this.formatterOptions.rowDelimiter, formattedCols].join('');
    }
    return formattedCols;
  }
}
exports.RowFormatter = RowFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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